import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const WishlistContext = createContext(null);
const KEY = "elvosh_wishlist";

export function WishlistProvider({ children }) {
    const { user } = useAuth();
    const [ids, setIds] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem(KEY)) || [];
        } catch {
            return [];
        }
    });

    const load = useCallback(async () => {
        if (user) {
            try {
                const { data } = await api.get("/wishlist");
                setIds(data.products.map((p) => p.id));
            } catch {
                /* ignore */
            }
        }
    }, [user]);

    useEffect(() => {
        if (user) load();
    }, [user, load]);

    useEffect(() => {
        if (!user) localStorage.setItem(KEY, JSON.stringify(ids));
    }, [ids, user]);

    const toggle = async (product_id) => {
        const has = ids.includes(product_id);
        setIds((prev) => (has ? prev.filter((i) => i !== product_id) : [...prev, product_id]));
        if (user) {
            try {
                if (has) await api.delete(`/wishlist/${product_id}`);
                else await api.post("/wishlist", { product_id });
            } catch {
                /* ignore */
            }
        }
        return !has;
    };

    const has = (id) => ids.includes(id);

    return (
        <WishlistContext.Provider value={{ ids, toggle, has, count: ids.length, reload: load }}>
            {children}
        </WishlistContext.Provider>
    );
}

export const useWishlist = () => useContext(WishlistContext);
